import { SupplierCompanyMessage } from '../../../types/SupplierCompanyMessage';
import { useToasts } from '../../cdl/Toast/useToasts';
import { updateSupplierDetails } from '../../common/api/clients/company.api';
import { queries } from '../../common/api/queryKeys/queries';
import { translate } from '../../common/helpers/translate.helper';
import { useOptimisticMutation } from '../../common/hooks/useOptimisticMutation';
import { queryClient } from '../../lib/queryClient';

interface UpdateSupplierDetailsVariables {
    id: string;
    supplierData: SupplierCompanyMessage;
}

export const useSupplierAdminSettingsOptimisticMutation = (supplierId: string) => {
    const { addErrorToast } = useToasts();

    return useOptimisticMutation<SupplierCompanyMessage, Error, UpdateSupplierDetailsVariables, SupplierCompanyMessage>(
        {
            mutationFn: updateSupplierDetails,
            optimisticUpdateOptions: {
                queryKey: queries.suppliers.detail(supplierId).queryKey,
                optimisticUpdatesFn: ({ prevQueryData, variables }) => {
                    return {
                        ...prevQueryData,
                        ...variables.supplierData,
                    };
                },
                invalidateQueryOnSuccess: false,
            },
            onError: () => {
                addErrorToast(translate('company.toasts.informationUpdateError'));
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: queries.suppliers._def });
            },
        }
    );
};
